'use strict';

var angular = require('angular'),
    uiRouter = require('angular-ui-router'),
    homeController = require('./home.ctrl'),
    home = require('./home.service');

module.exports = angular.module('App.home', ['App', uiRouter])
    .service('home', home)
    .controller('HomeController', homeController)
    .config(function ($stateProvider) {
        $stateProvider
            .state('root.home', {
                url: '/',
                views: {
                    'main@': {
                        templateUrl: 'components/home/home.tpl.html',
                        controller: 'HomeController as homeCtrl'
                    }
                }
            });
    });
